var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMapLayers = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 25,
  viewBox: "0 0 24 25",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.5119 3.1113C12.2282 2.96374 11.8927 2.96286 11.6083 3.10893L2.5 7.78736L11.6083 12.4658C11.8927 12.6119 12.2282 12.611 12.5119 12.4634L21.5 7.78736L12.5119 3.1113ZM12.0549 5.16505L6.9496 7.78736L12.0549 10.4097L17.0954 7.78736L12.0549 5.16505Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.5 12.5743L18.4708 10.9983L16.315 12.1683L17.0954 12.5743L12.0549 15.1966L6.94959 12.5743L7.71134 12.183L5.54775 11.0088L2.5 12.5743L11.6083 17.2527C11.8927 17.3988 12.2282 17.3979 12.5118 17.2503L21.5 12.5743Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M18.4708 15.6367L21.5 17.2126L12.5118 21.8887C12.2282 22.0363 11.8927 22.0371 11.6083 21.8911L2.5 17.2126L5.54775 15.6472L7.71134 16.8214L6.94959 17.2126L12.0549 19.835L17.0954 17.2126L16.315 16.8067L18.4708 15.6367Z"
})));
export default SvgMapLayers;